import wgcm from "@wg/wowscm";

const inGameUserAgentKeyword = "WOWS/1.0";

const appDiv = document.getElementById('app')
const cmWrapper = document.getElementById('cm-wrapper')

export function isIngame() {
    return navigator.userAgent.includes(inGameUserAgentKeyword);
}

export function initCommonmenu() {
    let userId = null;
    let userName = null;
    let accountInfo = window.__PRELOADED_STATE__.currentAccount;
    if (accountInfo) {
        userId = accountInfo.id;
        userName = accountInfo.nickname;
    }
    if (isIngame()) {
        document.getElementById(window.cm_settings.menuElementId).remove();
    } else {
        wgcm(userId, userName);
        if (cmWrapper) {
            cmWrapper.classList.add("cm-wrapper-visible");
        }
        if (appDiv) {
            appDiv.classList.add("not-ingame");
        }
    }
}